import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
// import "./Tableform.css";
import image from "../../../../images/logo1.png"
import {

} from '../../../actions/GenomicsSampleAccessioningActions';
import { connect } from 'react-redux';
import ReactToPrint from "react-to-print";

import { useRef } from 'react';
const useStyles = makeStyles({
    table: {
        height: "40px"
    },
    left: {
        margin: 600,
        width: "50%"
    },
    fontsize13: {
        fontSize: "13px",
    },
    rightContentHeader: {
        width: "88%",
        float: "left",
        textAlign: "left",
        paddingRight: "20px",
    },
    style: {
        background: "#AD70A6",
        color: "#fff",
        padding: 10,
        marginLeft: 5,
    }

});
interface Props {

}
const PhleboAdminViewBooking: React.FC<Props> = ({


}) => {


    const [id, setId] = useState<any>(0)


    // useEffect(() => {
    //     if (bookingId !== 0) {
    //         getBookingById(bookingId)
    //         getHivPackage(`?booking=${bookingId}`)

    //         getQRCodeData(bookingId)
    //         getSignature(bookingId)

    //     }
    // }, [bookingId])



    const classes = useStyles();
    const contentArea = useRef<any>(0)
    const componentRef = useRef<any>(null);
    //   const pid = booking && booking?.customer_name + "-" + booking && booking?.pk;
    const [personName, setPersonName] = useState<any>("main")
    // const handleExportWithFunction = () => {
    //     savePDF(contentArea.current, { paperSize: "A4"});
    //     //  window.print

    // }

    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);
    const reactToPrintTrigger = React.useCallback(() => {
        return <button style={{ marginLeft: "10px" }}>Print Receipt</button>;
    }, []);





    return (
        <>
            <div>
                <div style={{ height: "20px", marginTop: "35%" }}>
                    <h2></h2>
                    <div className={classes.rightContentHeader}>

                        <ReactToPrint
                            content={reactToPrintContent}
                            trigger={reactToPrintTrigger}
                        />
                    </div>
                </div>
            </div>
            <div
                style={{
                    width: 842,
                    background: "#f1f1f1",
                    margin: "20px auto",
                    padding: 20
                }}
            >

                <div ref={componentRef}>
                    <div style={{ width: "100%", display: "flex", background: "#ab003c", marginTop: "52px" }}>
                        <div style={{ width: "50%", textAlign: "left", padding: 15 }}>
                            <h3><img src={image} alt="logo" style={{ width: "150px" }} /></h3>
                        </div>
                        <div style={{ width: "50%", textAlign: "right", padding: 15 }}>
                            <div style={{ color: "white", fontWeight: "bold" }}><h3>Test Requistion Form</h3></div>
                        </div>
                    </div>

                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "flex-end",
                            margin: "10px 0px",
                            color: "#fff"
                        }}
                    >
                        <div style={{ background: "#ec407a", padding: 10 }}>Sample Id</div>
                        <div
                            style={{
                                padding: "8px 5px",
                                color: "#000",
                                border: "2px solid #000"
                            }}
                        >
                            RCL
                        </div>
                        <input></input>
                    </div>
                    <div
                        style={{
                            width: "100%",
                            background: "#ab003c",
                            textAlign: "center",
                            color: "#fff"
                        }}
                    >
                        <h3 style={{ padding: 8 }}>PATIENT DETAILS</h3>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                        <div style={{ background: "#ec407a", color: "#fff", padding: 10 }}>
                            First Name:
                        </div>
                        <input style={{ width: "36%", marginLeft: 5 }}></input>
                        <div
                            style={{
                                background: "#ec407a",
                                color: "#fff",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            Family Name:
                        </div>
                        <input style={{ width: "36.5%", marginLeft: 5 }}></input>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#ec407a", color: "#fff", padding: 10 }}>
                            DOB
                        </div>
                        <input type="date" style={{ width: "30%", marginLeft: 5 }}></input>
                        <div
                            style={{
                                background: "#ec407a",
                                color: "#fff",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            Ethnicity
                        </div>
                        <input style={{ width: "30%" }}></input>
                       
                        <div
                            style={{
                                background: "#ec407a",
                                color: "#fff",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            Consangunity
                        </div>
                        <div style={{ marginTop: 10, marginLeft: 5, width: "20%" }}>
                            <input type="radio" id="Y" value="Y" />  <label id="Y">Y</label>
                            <input type="radio" id="N" value="N" />  <label id="N">N</label>
                        </div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#ec407a", color: "#fff", padding: 10 }}>
                            Address
                        </div>
                        <input style={{ width: "100%", marginLeft: 5 }}></input>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#ec407a", color: "#fff", padding: 10 }}>
                            city
                        </div>
                        <input style={{ width: "40%", marginLeft: 5 }}></input>
                        <div
                            style={{
                                background: "#ec407a",
                                color: "#fff",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            State
                        </div>
                        <input style={{ width: "40%", marginLeft: 5 }}></input>
                        <div
                            style={{
                                background: "#ec407a",
                                color: "#fff",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            Pincode
                        </div>
                        <input style={{ width: "40%", marginLeft: 5 }}></input>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#ec407a", color: "#fff", padding: 10 }}>
                            PhoneNo.
                        </div>
                        <input type="number" style={{ width: "40%", marginLeft: 5 }}></input>
                        <div
                            style={{
                                background: "#ec407a",
                                color: "#fff",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            Email
                        </div>
                        <input type="email" style={{ width: "60%", marginLeft: 5 }}></input>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#ec407a", color: "#fff", padding: 10 }}>
                            Condition/Habit:
                        </div>
                        <div style={{ marginTop: 10, marginLeft: 10, display: "flex" }}>
                            <input
                                style={{ marginRight: 10 }}
                                type="checkbox"
                                id="Y"
                                value="Y"
                            />
                            <label id="Y">Smoking</label>
                        </div>
                        <div style={{ marginTop: 10, marginLeft: 10, display: "flex" }}>
                            <input
                                style={{ marginRight: 10 }}
                                type="checkbox"
                                id="Y"
                                value="Y"
                            />
                            <label id="Y">Alcohol</label>
                        </div>
                        <div style={{ marginTop: 10, marginLeft: 10, display: "flex" }}>
                            <input
                                style={{ marginRight: 10 }}
                                type="checkbox"
                                id="Y"
                                value="Y"
                            />
                            <label id="Y">Diabetes</label>
                        </div>
                        <div style={{ marginTop: 10, marginLeft: 10, display: "flex" }}>
                            <input
                                style={{ marginRight: 10 }}
                                type="checkbox"
                                id="Y"
                                value="Y"
                            />
                            <label id="Y">Other(Specify)</label>
                        </div>
                    </div>
                    
                    <div
                        style={{
                            width: "100%",
                            background: "#ab003c",
                            textAlign: "center",
                            color: "#fff"
                        }}
                    >
                        <h3 style={{ padding: 8 }}>CLINIC INDICATIONS</h3>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>

                        <div style={{ background: "#ec407a", color: "#fff", padding: 10 }}>
                            Weight
                        </div>
                        <input style={{ width: "40%", marginLeft: 5 }} />
                        <div
                            style={{
                                background: "#ec407a",
                                color: "#fff",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            Height
                        </div>
                        <input style={{ marginLeft: 5 ,width: "40%"}} />
                        <div style={{ background: "#ec407a", color: "#fff", padding: 10 }}>
                            LMP:
                        </div>
                        <input type="date" style={{ width: "30%", marginLeft: 5 }} />
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#ec407a", color: "#fff", padding: 10 }}>
                            Pregnancy Info:
                        </div>
                        <div style={{ marginTop: 10, marginLeft: 10, display: "flex" }}>
                            <input
                                style={{ marginRight: 10 }}
                                type="checkbox"
                                id="Y"
                                value="Y"
                            />
                            <label id="Y">Spontaneous</label>
                        </div>
                        <div style={{ marginTop: 10, marginLeft: 10, display: "flex" }}>
                            <input
                                style={{ marginRight: 10 }}
                                type="checkbox"
                                id="Y"
                                value="Y"
                            />
                            <label id="Y">IVF</label>
                        </div>
                        <div style={{ marginTop: 10, marginLeft: 10, display: "flex" }}>
                            <input
                                style={{ marginRight: 10 }}
                                type="checkbox"
                                id="Y"
                                value="Y"
                            />
                            <label id="Y">ICSI</label>
                        </div>
                        <div style={{ marginTop: 10, marginLeft: 10, display: "flex" }}>
                            <input
                                style={{ marginRight: 10 }}
                                type="checkbox"
                                id="Y"
                                value="Y"
                            />
                            <label id="Y">Others(specify)</label>
                        </div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div
                            style={{
                                marginTop: 10,
                                display: "flex",
                                width: "50%",
                                border: "2px solid black"
                            }}
                        >
                            <input
                                style={{ marginRight: 10 }}
                                type="checkbox"
                                id="Y"
                                value="Y"
                            />
                            <label id="Y">FFPE Tissue Block | Block No:</label>
                        </div>
                        <div
                            style={{
                                marginTop: 10,
                                marginLeft: 10,
                                display: "flex",
                                width: "50%",
                                border: "2px solid black"
                            }}
                        >
                            <input
                                style={{ marginRight: 10 }}
                                type="checkbox"
                                id="Y"
                                value="Y"
                            />
                            <label id="Y">Other Sample Site (Specify Site):</label>
                        </div>
                    </div>

                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#ec407a", color: "#fff", padding: 10 }}>
                            Mode Of Conceptions:
                        </div>
                        <div style={{ marginTop: 10, marginLeft: 10, display: "flex" }}>
                            <input
                                style={{ marginRight: 10 }}
                                type="checkbox"
                                id="Y"
                                value="Y"
                            />
                            <label id="Y">Spontaneous</label>
                        </div>
                        <div style={{ marginTop: 10, marginLeft: 10, display: "flex" }}>
                            <input
                                style={{ marginRight: 10 }}
                                type="checkbox"
                                id="Y"
                                value="Y"
                            />
                            <label id="Y">IVF</label>
                        </div>
                        <div style={{ marginTop: 10, marginLeft: 10, display: "flex" }}>
                            <input
                                style={{ marginRight: 10 }}
                                type="checkbox"
                                id="Y"
                                value="Y"
                            />
                            <label id="Y">ICSI</label>
                        </div>
                        <div style={{ marginTop: 10, marginLeft: 10, display: "flex" }}>
                            <input
                                style={{ marginRight: 10 }}
                                type="checkbox"
                                id="Y"
                                value="Y"
                            />
                            <label id="Y">Others(specify)</label>
                        </div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div
                            style={{
                                marginTop: 10,
                                display: "flex",
                                width: "50%",
                                border: "2px solid black"
                            }}
                        >
                            <input
                                style={{ marginRight: 10 }}
                                type="checkbox"
                                id="Y"
                                value="Y"
                            />
                            <label id="Y">FFPE Tissue Block | Block No:</label>
                        </div>
                        <div
                            style={{
                                marginTop: 10,
                                marginLeft: 10,
                                display: "flex",
                                width: "50%",
                                border: "2px solid black"
                            }}
                        >
                            <input
                                style={{ marginRight: 10 }}
                                type="checkbox"
                                id="Y"
                                value="Y"
                            />
                            <label id="Y">Other Sample Site (Specify Site):</label>
                        </div>
                    </div>
                    <div
                        style={{
                            width: "100%",
                            background: "#ab003c",
                            textAlign: "center",
                            color: "#fff"
                        }}
                    >
                        <h3 style={{ padding: 8 }}>CLINIC DETAILS</h3>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                        <div style={{ background: "#ec407a", color: "#fff", padding: 10 }}>
                            Name:
                        </div>
                        <input style={{ width: "40%", marginLeft: 5 }}></input>
                        <div
                            style={{
                                background: "#ec407a",
                                color: "#fff",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            Hospital:
                        </div>
                        <input style={{ width: "40%", marginLeft: 5 }}></input>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                        <div style={{ background: "#ec407a", color: "#fff", padding: 10 }}>
                            Address:
                        </div>
                        <input style={{ width: "100%", marginLeft: 5 }}></input>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#ec407a", color: "#fff", padding: 10 }}>
                            Phone Number:
                        </div>
                        <input type="number" style={{ width: "35%", marginLeft: 5 }}></input>
                        <div
                            style={{
                                background: "#ec407a",
                                color: "#fff",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            Email Id:
                        </div>
                        <input type="email" style={{ width: "37.4%", marginLeft: 5 }}></input>
                    </div>
                    <div
                        style={{
                            width: "100%",
                            margin: "10px 0px",
                            border: "1px solid",
                            height: "110px"
                        }}
                    >
                        <div style={{ padding: 10, width: "100%" }}>
                            I am ordering the test(s) for my patient above. I certify that
                            appropriate information has been provided regarding testing and the
                            patient has consented to get the test performed at your labroratory.
                        </div>
                        <div style={{ width: "100%", display: "flex" }}>
                            <div style={{ padding: 10, textAlign: "left", width: "50%" }}>
                                Date:
                                <hr
                                    style={{
                                        marginLeft: "50px",
                                        border: "none",
                                        borderTop: "1px dashed #000",
                                        color: "#fff",
                                        backgroundColor: "#fff",
                                        height: "1px",
                                        width: "50%"
                                    }}
                                />
                            </div>
                            <div style={{ padding: 10, textAlign: "left", width: "50%" }}>
                                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Clininc's Signature:
                                <hr
                                    style={{
                                        marginRight: "0px",
                                        border: "none",
                                        borderTop: "1px dashed #000",
                                        color: "#fff",
                                        backgroundColor: "#fff",
                                        height: "1px",
                                        width: "50%"
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        style={{
                            width: "100%",
                            background: "#ab003c",
                            textAlign: "center",
                            color: "#fff"
                        }}
                    >
                        <h3 style={{ padding: 8 }}>CLINIC NOTES & FAMILY HISTORY</h3>
                    </div>

                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <input
                            type="input"
                            style={{ width: "100%", height: "150px" }}
                        ></input>
                    </div>

                    <footer
                        style={{
                            background: "#ec407a",
                            textAlign: "center",
                            padding: "20px",
                            color: "#fff",
                            border: "2px solid black"
                        }}
                    >
                        <p>
                            <b>Redcliffe Lifesciences Pvt. Ltd.</b> &nbsp;{" "}
                            <p style={{ display: "inline" }}>
                                Building No: 14, 2nd Floor, Kausalya Park, Hauz Khas, New Delih
                                110016
                            </p>
                        </p>

                        <p>
                            Phone: +91-8882-914-915 | &nbsp; Email: care@redcliffelabs.com | &nbsp; Website: www.redcliffelabs.com
                        </p>
                    </footer>



                    {/* page2 */}
                    <div
                        style={{
                            width: "100%",
                            background: "#ab003c",
                            textAlign: "center",
                            color: "#fff"
                        }}
                    >
                        <h3 style={{ padding: 8 }}>
                            DETAILS OF ACCOMPANYING SAMPLES (IF ANY)
                        </h3>
                    </div>
                    {/* here */}

                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div
                            style={{
                                background: "#ec407a",
                                color: "#fff",
                                padding: 10,
                                width: "40%"
                            }}
                        >
                            Name
                        </div>
                        <div
                            style={{
                                background: "#ec407a",
                                color: "#fff",
                                padding: 10,
                                width: "15%",
                                marginLeft: "5px"
                            }}
                        >
                            Age
                        </div>
                        <div
                            style={{
                                background: "#ec407a",
                                color: "#fff",
                                padding: 10,
                                width: "20%",
                                marginLeft: "5px"
                            }}
                        >
                            Gender
                        </div>
                        <div
                            style={{
                                background: "#ec407a",
                                color: "#fff",
                                padding: 10,
                                width: "25%",
                                marginLeft: "5px"
                            }}
                        >
                            Relationship:
                        </div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <input style={{ width: "36.5%" }} />
                        <input style={{ width: "14.5%", marginLeft: "10px" }} />
                        <div
                            style={{
                                marginTop: 10,
                                marginLeft: 5,
                                width: "19.5%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >
                            <input type="radio" id="M" value="M" />  <label id="M">M</label>
                            <input type="radio" id="F" value="F" />  <label id="F">F</label>
                        </div>
                        <input style={{ width: "24%", marginLeft: "12px" }} />
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <input style={{ width: "36.5%" }} />
                        <input style={{ width: "14.5%", marginLeft: "10px" }} />
                        <div
                            style={{
                                marginTop: 10,
                                marginLeft: 5,
                                width: "19.5%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >
                            <input type="radio" id="M" value="M" />  <label id="M">M</label>
                            <input type="radio" id="F" value="F" />  <label id="F">F</label>
                        </div>
                        <input style={{ width: "24%", marginLeft: "12px" }} />
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <input style={{ width: "36.5%" }} />
                        <input style={{ width: "14.5%", marginLeft: "10px" }} />
                        <div
                            style={{
                                marginTop: 10,
                                marginLeft: 5,
                                width: "19.5%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >
                            <input type="radio" id="M" value="M" />  <label id="M">M</label>
                            <input type="radio" id="F" value="F" />  <label id="F">F</label>
                        </div>
                        <input style={{ width: "24%", marginLeft: "12px" }} />
                    </div>

                    <div
                        style={{
                            width: "100%",
                            background: "#ab003c",
                            textAlign: "center",
                            color: "#fff"
                        }}
                    >
                        <h3 style={{ padding: 8 }}>TERMS & CONDITIONS</h3>
                    </div>

                    <div style={{ display: "flex", width: "100%" }}>
                        <div style={{ columnCount: "1", width: "50%" }}>
                            <h3 style={{ margin: "1px 0 0 0" }}>Delivery of Services</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
                                nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam
                                erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci
                                tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                                consequat.
                            </p>
                            <h3 style={{ margin: "1px 0 0 0" }}>Reports</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
                                nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam
                                erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci
                                tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                                consequat.Lorem ipsum dolor sit amet, consectetuer adipiscing
                                elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore
                                magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                                nostrud exerci tation ullamcorper suscipit lobortis nisl ut
                                aliquip ex ea commodo consequat. Ut wisi enim ad minim veniam,
                                quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut
                                aliquip ex ea commodo consequat.
                            </p>
                            <h3 style={{ margin: "1px 0 0 0" }}>Fees</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
                                nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam
                                erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci
                                tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                                consequat.Lorem ipsum dolor sit amet, consectetuer adipiscing
                                elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore
                                magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                                nostrud exerci tation ullamcorper suscipit lobortis nisl ut
                                aliquip ex ea commodo consequat. Ut wisi enim ad minim veniam,
                                quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut
                                aliquip ex ea commodo consequat.
                            </p>
                            <h3 style={{ margin: "1px 0 0 0" }}>Roles & Responsbilties</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
                                nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam
                                erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci
                                tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                                consequat.Lorem ipsum dolor sit amet, consectetuer adipiscing
                                elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore
                                magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                                nostrud exerci tation ullamcorper suscipit lobortis nisl ut
                                aliquip ex ea commodo consequat. Ut wisi enim ad minim veniam,
                                quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut
                                aliquip ex ea commodo consequat.
                            </p>
                        </div>
                        <div style={{ columnCount: "1", width: "50%" }}>
                            <h3 style={{ margin: "1px 0 0 0" }}>Term</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
                                nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam
                                erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci
                                tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                                consequat.
                            </p>
                            <h3 style={{ margin: "1px 0 0 0" }}>Termination</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
                                nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam
                                erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci
                                tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                                consequat.Lorem ipsum dolor sit amet, consectetuer adipiscing
                                elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore
                                magna aliquam erat volutpat.
                            </p>
                            <h3 style={{ margin: "1px 0 0 0" }}>Limitation of Liability</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
                                nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam
                                erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci
                                tation ullamcorper suscipit lobortis nisl.
                            </p>
                            <h3 style={{ margin: "1px 0 0 0" }}>
                                Governing Law, Juridisction & Dispute Resolution
                            </h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
                                nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam
                                erat volutpat..
                            </p>
                            <h3 style={{ margin: "1px 0 0 0" }}>Notice</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
                                nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam
                                erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci
                                tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                                consequat.Lorem ipsum dolor sit amet, consectetuer adipiscing
                                elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore
                                magna aliquam erat volutpat.
                            </p>
                            <h3 style={{ margin: "1px 0 0 0" }}>Independent Parties</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
                                nonummy nibh euismod.
                            </p>
                            <h3 style={{ margin: "1px 0 0 0" }}>Refund</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
                                nonummy nibh euismod. Consectetuer adipiscing elit, sed diam
                                nonummy nibh euismod
                            </p>
                        </div>
                    </div>
                    <div
                        style={{
                            width: "100%",
                            background: "#ab003c",
                            textAlign: "center",
                            color: "#fff"
                        }}
                    >
                        <h3 style={{ padding: 8 }}>PAYMENT INSTRUCTIONS</h3>
                    </div>

                    <div style={{ background: "#81ecec", padding: "20px" }}>
                        <div
                            style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >
                            <input style={{ width: "15%", height: "30px" }} />
                            <input style={{ width: "15%", marginLeft: 5, height: "30px" }} />
                            <p style={{ marginLeft: 5 }}>
                                DD/Cheque should check be drawn in favor of{" "}
                                <b>"Redcliffe Life Sciences Pvt. Ltd."</b> Payable at{" "}
                                <b>"Delhi"</b>.
                            </p>
                        </div>

                        <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                            <div style={{ background: "#ec407a", color: "#fff", padding: 10 }}>
                                DD/Cheque No./Ref No:
                            </div>
                            <input style={{ marginLeft: 5, width: "14%" }}></input>
                            <div
                                style={{
                                    background: "#ec407a",
                                    color: "#fff",
                                    padding: 10,
                                    marginLeft: 5
                                }}
                            >
                                Bank:
                            </div>
                            <input style={{ marginLeft: 5, width: "24%" }}></input>
                            <div
                                style={{
                                    background: "#ec407a",
                                    color: "#fff",
                                    padding: 10,
                                    marginLeft: 5
                                }}
                            >
                                Date:
                            </div>
                            <input type="date" style={{ marginLeft: 5 }}></input>
                        </div>
                        <div
                            style={{
                                background: "#81ecec",
                                textAlign: "center",
                                padding: "5px",
                                color: "#000"
                            }}
                        >
                            <p>
                                <b>
                                    On Line Transfer or Direct Cast Deposit to, "Redcliffe Life
                                    Sciences Pvt. Ltd."
                                </b>
                                <br></br>
                                <b>
                                    Account #: 26295259694, IFSC CODE: "BARB0NOIDAX" NOIDA Branch.
                                </b>
                                <br></br>
                                <b>
                                    Kindly Notify prior to deciding the mode of payment and confirm
                                    transactions at the earliest.
                                </b>
                            </p>
                        </div>
                    </div>

                    <footer
                        style={{
                            background: "#ec407a",
                            textAlign: "center",
                            padding: "20px",
                            color: "#fff",
                            border: "2px solid black"
                        }}
                    >
                        <p>
                            <b>Redcliffe Lifesciences Pvt. Ltd.</b> &nbsp;{" "}
                            <p style={{ display: "inline" }}>
                                Building No: 14, 2nd Floor, Kausalya Park, Hauz Khas, New Delih
                                110016
                            </p>
                        </p>

                        <p>
                            Phone: +91-8882-914-915 | &nbsp; Email: care@redcliffelabs.com |
                            &nbsp; Website: www.redcliffelabs.com
                        </p>
                    </footer>


















                </div>
            </div>
        </>
    );
}
const mapStateToProps = (state: any) => ({


})

export default connect(mapStateToProps, {

})(PhleboAdminViewBooking);